var _style, _path, _circle, _path2, _rect, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _polygon2, _polygon3, _rect2, _rect3, _rect4, _rect5, _polygon4, _path1, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSignalTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 123.7 120.1",
    style: {
      enableBackground: "new 0 0 123.7 120.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#243038;}\n\t.st1{fill:#B2BAC1;}\n\t.st2{fill:#ECEEEF;}\n\t.st3{fill:#798792;}\n\t.st4{fill:#F7931E;}\n\t.st5{fill:none;}\n\t.st6{fill:#FBC98E;}\n\t.st7{fill:#F88387;}\n\t.st8{fill:#FDD79D;}\n\t.st9{fill:#80DA8B;}\n\t.st10{fill:#E39CD6;}\n\t.st11{fill:#80CBF2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.8,24.7L39.2,8.6c0-1.9-1.2-3.6-3.1-4.1c-2.2-0.5-4.4,0.8-5,3c-0.5,2.2,0.8,4.4,3,5c1.8,0.5,3.7-0.3,4.6-2 l61.6,16.1c0.1,0,0.2,0,0.3,0c0.4,0,0.8-0.3,1-0.7C101.6,25.4,101.3,24.9,100.8,24.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 93.7,
    cy: 33.1,
    r: 16.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.7,50.3c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2s17.2,7.7,17.2,17.2 C110.9,42.6,103.2,50.3,93.7,50.3z M93.7,17.9c-8.4,0-15.2,6.8-15.2,15.2s6.8,15.2,15.2,15.2s15.2-6.8,15.2-15.2 S102.1,17.9,93.7,17.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6,
    y: 100.9,
    className: "st1",
    width: 97.4,
    height: 9.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,111H11.6V99.9H111V111z M13.6,109H109v-7.1H13.6V109z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.7,102.2c-34,2.1-67.9,2.1-101.9,0c-2.2-0.1-4.3-2.1-4.6-4.3c-2.9-22.1-2.9-44.1,0-66.2 c0.3-2.2,2.4-4.1,4.6-4.3c34-2.1,67.9-2.1,101.9,0c2.2,0.1,4.3,2.1,4.6,4.3c2.9,22.1,2.9,44.1,0,66.2 C117,100.1,114.9,102,112.7,102.2z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 102.9,
    cy: 48.3,
    r: 9.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 102.9,
    cy: 65.2,
    r: 2.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 95.5,
    cy: 65.2,
    r: 2.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 110.3,
    cy: 65.2,
    r: 2.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,37.5c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8c6,0,10.8-4.8,10.8-10.8S108.9,37.5,102.9,37.5z  M102.9,39.5c1.1,0,2.2,0.2,3.2,0.6L94.6,51.2c-0.3-0.9-0.5-1.9-0.5-2.9C94.1,43.4,98,39.5,102.9,39.5z M95.5,53.1l12.4-12 c0.9,0.6,1.7,1.5,2.3,2.4l-12.5,12C96.9,54.8,96.1,54,95.5,53.1z M102.9,57.1c-1.1,0-2.2-0.2-3.2-0.6l11.5-11.1 c0.3,0.9,0.5,1.9,0.5,2.9C111.7,53.2,107.8,57.1,102.9,57.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,74.1H93.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h19.6c0.6,0,1,0.4,1,1S113.3,74.1,112.7,74.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,77.4H93.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h19.6c0.6,0,1,0.4,1,1S113.3,77.4,112.7,77.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,80.8H93.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h19.6c0.6,0,1,0.4,1,1S113.3,80.8,112.7,80.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,84.2H93.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h19.6c0.6,0,1,0.4,1,1S113.3,84.2,112.7,84.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.4,35.1c25.3-2.1,57.6-1.4,71,0c3.1,29.6,0.9,55.7,0,59.5c-30.4,3.4-48.9,2-71,0 C11.4,74.7,11.4,53.8,13.4,35.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "13.4,34.8 30.4,34.3 30.4,76.4 11.9,76.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "11.9,76.4 30.4,76.4 30.4,95.8 13.2,95 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "67.5,76.4 86,76.4 84.7,95.1 67.5,95.8 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4,
    y: 76.4,
    className: "st9",
    width: 18.5,
    height: 19.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 76.4,
    className: "st10",
    width: 18.5,
    height: 19.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.4,
    y: 34.3,
    className: "st11",
    width: 18.5,
    height: 42.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 34.3,
    className: "st7",
    width: 18.5,
    height: 42.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "67.5,34.3 84.8,34.7 86,76.4 67.5,76.4 "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.4,35l-0.1-0.8l-0.8-0.1c-13.2-1.4-45.3-2.1-71.2,0l-0.8,0.1L12.4,35c-2,18.7-2,39.9,0,59.7l0.1,0.8l0.8,0.1 c13.1,1.2,24.4,2.1,36.9,2.1c10.1,0,21.1-0.6,34.3-2.1l0.7-0.1l0.2-0.7C86.4,90.4,88.4,64,85.4,35z M84.9,75.4H68.5V35.1 c6,0.2,11.2,0.5,15,0.9C85,51.1,85.2,64.9,84.9,75.4z M31.4,75.4V35.1c5.6-0.2,11.2-0.3,16.6-0.3v40.6H31.4z M48,77.4v18.3 c-5.6,0-11.1-0.3-16.6-0.6V77.4H48z M50,34.8c5.8,0,11.4,0.1,16.5,0.3v40.4H50V34.8z M14.3,36c4.9-0.4,10-0.7,15.1-0.9v40.3H13.1 C12.6,61.9,13,48.4,14.3,36z M13.2,77.4h16.2v17.5c-4.9-0.3-9.8-0.8-15.1-1.2C13.8,88.3,13.4,82.9,13.2,77.4z M50,95.7V77.4h16.5 v17.8C60.6,95.5,55.2,95.7,50,95.7z M83.6,93.7c-5.4,0.6-10.4,1-15.1,1.3V77.4h16.3C84.5,85.6,83.9,91.4,83.6,93.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.5,68.6c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4C98.9,67.1,97.4,68.6,95.5,68.6z  M95.5,63.8c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4C96.9,64.4,96.3,63.8,95.5,63.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,68.6c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4 C106.3,67.1,104.8,68.6,102.9,68.6z M102.9,63.8c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4 C104.3,64.4,103.7,63.8,102.9,63.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.3,68.6c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4 C113.7,67.1,112.2,68.6,110.3,68.6z M110.3,63.8c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4 C111.7,64.4,111.1,63.8,110.3,63.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,104.8c-17,0-34.1-0.5-51-1.6c-2.6-0.1-5.2-2.5-5.5-5.2C2.3,76,2.3,53.6,5.2,31.6c0.4-2.7,2.8-4.9,5.5-5.2 c33.9-2.1,68.2-2.1,102.1,0c2.6,0.1,5.2,2.5,5.5,5.2c2.9,22.1,2.9,44.4,0,66.5c-0.4,2.7-2.8,4.9-5.5,5.2l0,0 C95.8,104.2,78.8,104.8,61.8,104.8z M61.7,26.8c-17,0-34,0.5-50.9,1.6c-1.7,0.2-3.4,1.7-3.7,3.4c-2.9,21.9-2.9,44.1,0,65.9 c0.2,1.7,1.9,3.4,3.7,3.4c33.8,2.1,68,2.1,101.8,0c1.8-0.2,3.5-1.7,3.7-3.4c2.9-21.9,2.9-44.1,0-65.9c-0.2-1.7-1.9-3.4-3.7-3.4 C95.8,27.4,78.8,26.8,61.7,26.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSignalTv);
export default __webpack_public_path__ + "static/media/no-signal-tv.207c9927af0243cc1d598e5216b9f848.svg";
export { ForwardRef as ReactComponent };